<template>
  <v-tooltip bottom>
    <template #activator="{ on }">
      <v-btn class="hover-primary" icon v-on="on" @click="convertOfferToModelOffer">
        <v-icon>mdi-axis-arrow</v-icon>
      </v-btn>
    </template>
    <span>Transformer en modèle</span>
  </v-tooltip>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import store from '@/store';
import router from '@/router';

import { requests } from '@/mixins/index';

const emit = defineEmits(['set-loading']);

const props = defineProps({
  offerUuid: {
    type: String,
    default: null
  }
});

const convertOfferToModelOffer = async () => {
  store.commit('setDialog', {
    show: true,
    title: '<p class="col-12 text-center pa-0 mb-0">⚠️ Attention au contenu du Modèle !</p>',
    text: '<p class="text-center">Vous êtes sur le point de transformer cette offre en Modèle Multi-Sites.<br><strong>Pensez à supprimer ou à neutraliser toute mention spécifique à l\'établissement actuel </strong>(ex : Nom, description du site, adresse) dans le texte de l\'offre. Ces informations seront automatiquement réinjectées lors de la diffusion sur les Workspaces cibles.</p>',
    acceptText: 'Continuer',
    handleAccept: async () => {
      emit('set-loading', true);
      try {
        const response = await requests.saveModelOffer({ offerUuid: props.offerUuid });

        if (!response.success) {
          store.commit('setSnackbar', { message: response.message, color: 'error' });
          return;
        }

        store.dispatch('updateWorkspace', store.state.centralizedWorkspace);
        store.commit('resetDialog');
        router.push({ name: 'model_offer', params: { contentTypeLabel: 'modeles-d-offres', mode: 'editer', uuid: response.data.uuid } });
      } catch (error) {
        store.commit('setSnackbar', { message: error.message, color: 'error' });
      } finally {
        emit('set-loading', false);
      }
    }
  });
};
</script>
